import { type HeadProps } from "./Head.interface";
import { i18n } from "@/configuration/i18n/i18n";
import { Helmet } from "react-helmet-async";

const Head = ({ titre, description }: HeadProps) => {
  return (
    <Helmet>
      <title>{titre ? `${titre} - ${i18n.APP.NOM}` : `${i18n.APP.NOM}`}</title>
      {description && (
        <meta
          content={description}
          name="description"
        />
      )}
    </Helmet>
  );
};

export default Head;
